// zapiet-PREDICTIVESEARCH-Badge.js
// Optimized version: Enhanced performance, same logic

(function () {

  /* ==================== CACHING LAYER ==================== */
  
  // Cache badge elements to avoid repeated DOM queries
  const badgeCache = new WeakMap();
  const cardStateCache = new WeakMap();
  
  // Cache Zapiet data to reduce redundant lookups
  let zapietDataCache = null;
  let zapietCacheTime = 0;
  const ZAPIET_CACHE_DURATION = 5000; // 5 seconds

  function getCachedZapietData() {
    const now = Date.now();
    
    if (zapietDataCache && (now - zapietCacheTime) < ZAPIET_CACHE_DURATION) {
      return zapietDataCache;
    }

    const r = window.ZapietEats?.getSelectedRestaurant?.();
    const m = window.ZapietEats?.getSelectedMenu?.();
    const dRaw = window.ZapietEats?.getSelectedDate?.();
    const vm = window.ZapietWidgetConfig?.variant_metafields;

    if (!r || !m || !dRaw || !vm) return null;

    let selectedDate = null;
    try {
      const d = new Date(dRaw);
      d.setDate(d.getDate() - 1);
      selectedDate = d.toISOString().split("T")[0];
    } catch {}

    const menuVariantIds = [];
    m?.menu_sections?.forEach(sec => {
      sec?.menu_section_items?.forEach(it => {
        if (it?.product?.variant_id)
          menuVariantIds.push(String(it.product.variant_id));
      });
    });
    const menuSet = new Set(menuVariantIds);

    const deliveryOption =
      window.ZapietEats?.getDeliveryOption?.() === "pickup"
        ? "store_pickup"
        : "local_delivery";

    const restrictions =
      m?.config?.[deliveryOption]?.product_date_restrictions || [];

    zapietDataCache = { r, m, vm, selectedDate, menuSet, restrictions };
    zapietCacheTime = now;

    return zapietDataCache;
  }

  function clearZapietCache() {
    zapietDataCache = null;
    zapietCacheTime = 0;
  }

  /* ==================== BADGE INJECTION (Optimized) ==================== */

  function injectBadge(card, text, cls) {
    try {
      // Check if state changed before updating
      const newState = `${text}|${cls}`;
      const oldState = cardStateCache.get(card);
      
      if (oldState === newState) return; // Skip if unchanged
      cardStateCache.set(card, newState);

      const imgWrap =
        card.querySelector(".t4s-search-fullwidth__image") || card;

      if (getComputedStyle(imgWrap).position === "static") {
        imgWrap.style.position = "relative";
      }

      let badge = badgeCache.get(card);
      
      if (!badge) {
        badge = imgWrap.querySelector(".zapiet-badge");
        if (!badge) {
          badge = document.createElement("div");
          badge.className = "zapiet-badge";
          imgWrap.prepend(badge);
        }
        badgeCache.set(card, badge);
      }

      // Only update if different
      if (badge.textContent !== text) {
        badge.textContent = text;
      }
      badge.className = `zapiet-badge ${cls}`;
    } catch (e) {}
  }

  // Cache gray-out state
  const grayedCards = new WeakSet();

  function grayOutCard(card) {
    try {
      if (grayedCards.has(card)) return; // Already grayed
      grayedCards.add(card);

      card.classList.add("pred-disabled");

      const link = card.querySelector("a");
      if (link) {
        link.style.pointerEvents = "none";
        link.style.opacity = "0.5";
      }
    } catch (e) {}
  }

  function addStyleOnce() {
    if (document.getElementById("predictive-badge-style")) return;

    const st = document.createElement("style");
    st.id = "predictive-badge-style";
    st.innerHTML = `
      .zapiet-badge {
        font-weight:500;
        padding:4px 6px;
        font-size:11px;
        position:absolute;
        top:8px;
        left:5px;
        border-radius:3px;
        z-index:10;
        pointer-events:none;
        color:#fff;
        min-width:64px;
        text-align:center;
        line-height:1;
        box-shadow:0 2px 6px rgba(0,0,0,.18);
      }

      .predictive-badge-available { background:rgba(0,207,131,.97) !important; }
      .predictive-badge-limited { background:rgba(255,193,7,.92) !important; }
      .predictive-badge-unavailable { background:rgba(128,128,128,.92) !important; }
      .predictive-badge-soldout { background:rgba(128,128,128,.92) !important; }
      .predictive-badge-not-in-menu { background:rgba(128,128,128,.92) !important; }

      .pred-disabled {
        opacity: 100% !important;
        filter:grayscale(50%) !important;
        pointer-events:none !important;
      }
    `;
    document.head.appendChild(st);
  }

  // Cache parsed variant IDs
  const variantIdCache = new WeakMap();

  function parseVariantIds(card) {
    // Check cache first
    if (variantIdCache.has(card)) {
      return variantIdCache.get(card);
    }

    const raw = card.getAttribute("data-variant-ids");
    let result = [];

    if (!raw) {
      variantIdCache.set(card, result);
      return result;
    }

    try {
      result = JSON.parse(raw).map(String);
    } catch (e) {
      try {
        result = JSON.parse(raw.replace(/'/g, '"')).map(String);
      } catch (e2) {
        result = (raw.match(/\d+/g) || []).map(String);
      }
    }

    variantIdCache.set(card, result);
    return result;
  }

  /* ==================== BADGE LOGIC (Optimized) ==================== */

  function isSoldOut(vmObj, rid, mid, date, vid) {
    const vData = vmObj?.[vid];
    if (!vData) return false;

    const key = Object.keys(vData).find(
      k =>
        k.includes(String(rid)) &&
        k.includes(String(mid)) &&
        k.includes(date)
    );
    const inv = key ? vData[key] : null;

    return (
      inv?.toggled_off ||
      (typeof inv?.remaining === "number" && inv.remaining <= 0)
    );
  }

  function isRestricted(restrList, vid, date) {
    return restrList?.some(
      r =>
        String(r.variant_id) === String(vid) &&
        r.restricted_dates?.includes(date) &&
        (r.restriction_type === "deny" ||
          r.restriction_type === "DENY")
    );
  }

  function evaluateCard(card, data) {
    const { r, m, vm, selectedDate, menuSet, restrictions } = data;
    const ids = parseVariantIds(card);

    if (!ids.length) {
      injectBadge(card, "UNAVAILABLE", "predictive-badge-unavailable");
      grayOutCard(card);
      return;
    }

    const allNotMenu = ids.every(id => !menuSet.has(id));
    if (allNotMenu) {
      injectBadge(card, "NOT IN MENU", "predictive-badge-not-in-menu");
      grayOutCard(card);
      return;
    }

    const sold = ids.map(id =>
      isSoldOut(vm, r.id, m.id, selectedDate, id)
    );
    const restr = ids.map(id =>
      isRestricted(restrictions, id, selectedDate)
    );

    const allSold = sold.every(Boolean);
    const allRestr = restr.every(Boolean);
    const partial =
      !allSold &&
      !allRestr &&
      (sold.some(Boolean) || restr.some(Boolean));

    if (allSold) {
      injectBadge(card, "SOLD OUT TODAY", "predictive-badge-soldout");
      grayOutCard(card);
    } else if (allRestr) {
      injectBadge(card, "UNAVAILABLE", "predictive-badge-unavailable");
      grayOutCard(card);
    } else if (partial) {
      injectBadge(card, "LIMITED", "predictive-badge-limited");
    } else {
      injectBadge(card, "IN STOCK", "predictive-badge-available");
    }
  }

  /* ==================== MAIN RUNNER (Optimized) ==================== */

  let isProcessing = false;

  function runPredictiveBadges() {
    // Prevent overlapping executions
    if (isProcessing) return;
    isProcessing = true;

    try {
      addStyleOnce();

      const cards = document.querySelectorAll(".predictive-card");
      if (!cards.length) {
        isProcessing = false;
        return;
      }

      const data = getCachedZapietData();
      if (!data) {
        isProcessing = false;
        return;
      }

      // Process cards in requestAnimationFrame for better performance
      requestAnimationFrame(() => {
        try {
          cards.forEach(card => evaluateCard(card, data));
        } catch (e) {}
        isProcessing = false;
      });
    } catch (e) {
      isProcessing = false;
    }
  }

  /* ==================== DEBOUNCED TRIGGER ==================== */

  let rafId = null;
  let timeoutId = null;

  function scheduleRun() {
    if (rafId) cancelAnimationFrame(rafId);
    if (timeoutId) clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      rafId = requestAnimationFrame(runPredictiveBadges);
    }, 80);
  }

  /* ==================== SMART MUTATION OBSERVER ==================== */

  function setupObserver() {
    let lastCardCount = 0;

    const obs = new MutationObserver((mutations) => {
      // Only trigger if predictive cards actually changed
      const currentCards = document.querySelectorAll(".predictive-card");
      
      if (currentCards.length !== lastCardCount) {
        lastCardCount = currentCards.length;
        scheduleRun();
        return;
      }

      // Check if mutations added predictive cards
      const hasNewCards = mutations.some(m =>
        Array.from(m.addedNodes).some(node =>
          node.nodeType === 1 && (
            node.matches?.(".predictive-card") ||
            node.querySelector?.(".predictive-card")
          )
        )
      );

      if (hasNewCards) {
        scheduleRun();
      }
    });

    obs.observe(document.body, { 
      childList: true, 
      subtree: true,
      attributes: false, // Don't watch attribute changes
      characterData: false // Don't watch text changes
    });
  }

  /* ==================== INITIALIZATION ==================== */

  function init() {
    // Use requestIdleCallback for non-blocking init
    const startProcessing = () => {
      addStyleOnce();
      setupObserver();
      scheduleRun();
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(startProcessing, { timeout: 100 });
    } else {
      if (document.readyState !== "loading") {
        setTimeout(startProcessing, 60);
      } else {
        document.addEventListener("DOMContentLoaded", () =>
          setTimeout(startProcessing, 60)
        );
      }
    }

    // Clear cache and re-run on Zapiet changes
    const handleZapietChange = () => {
      clearZapietCache();
      cardStateCache.clear?.(); // Clear if supported
      scheduleRun();
    };

    document.addEventListener("zapieteats:ready", handleZapietChange);
    document.addEventListener("zapieteats:change", handleZapietChange);
    document.addEventListener("predictive:updated", scheduleRun);
  }

  init();
})();